
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { DashCircle, List, PencilFill } from "react-bootstrap-icons";
import { faSlidersH } from "@fortawesome/free-solid-svg-icons";
import { Button, Card, Col, Row, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalAccountLevel3 from "../../Components/Modals/ModalAccountLevel3";
import { keyIsLetterOrNumber, setErrorDialog } from "../../store/api/CommonFunctions";
import { getAllMappings, editAutoDocumentMapping } from "../store/api/DocumentsAPI";

const AutoDocumentMapping = () => {
    const { handleSubmit } = useForm();
    const dispatch = useDispatch();
    const [mapping, getMapping] = useState([]);
    const [currentRow, setCurrentRow] = useState(null);
    const [popAccLevel3, setPopAccLevel3] = useState({ show: false });
    function showModalAccLevel3(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSetData = (data) => {
            if (data) {
                setCurrentRow({ ...currentRow, HardCodeLevelThree: data.HardCode_LevelThree, AccountNameLevelThree: data.AccountName });
            }
        }
        setPopAccLevel3({ show: true, setAccData: onSetData, hasHardCode: true, value: e.key });
    }
    function onSubmit() {
        const onSuccess = () => {
            setErrorDialog(dispatch, "عملیات با موفقیت انجام شد", "ویرایش تنظیمات");
            setCurrentRow(null);
            getAllMappings(getMapping);
        }
        editAutoDocumentMapping(currentRow, onSuccess);
    }
    useEffect(() => {
        document.body.classList = "notMain";
        getAllMappings(getMapping);
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            {popAccLevel3.show && <ModalAccountLevel3 popData={popAccLevel3} setAccLevel3Popup={setPopAccLevel3} />}
            <Card>
                <Card.Header className="headerStyle" style={{ textAlign: "right" }}>
                    <FontAwesomeIcon icon={faSlidersH} size="lg" />
                    &nbsp;
                    تنظیمات کدینگ سندهای خودکار
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ minHeight: "75vh" }}>
                    {currentRow &&
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Row className="rowBorder">
                                <Col md={2} className="form-group">
                                    <label>نوع موجودیت</label>
                                    <input type="text" className="form-control" readOnly value={currentRow ? currentRow.DocumentForDesc : ""} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>نام فیلد</label>
                                    <input type="text" className="form-control" readOnly value={currentRow ? currentRow.DocRowAutoColumnDesc : ""} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>تفصیلی مرتبط</label>
                                    <input type="text" className="form-control" readOnly value={currentRow ? currentRow.AccountNameLevelThree : ""} onKeyDown={showModalAccLevel3} />
                                    <Button className="btn-input-tiny" onClick={showModalAccLevel3}><List size={18} /></Button>
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>&nbsp;</label>
                                    <div>
                                        <Button type="submit" variant="success" className="group-Btn mt-1"><PencilFill size={14} />&nbsp; ثبت اطلاعات</Button>
                                        <Button variant="danger" className="group-Btn mt-1" onClick={() => setCurrentRow(null)}><DashCircle size={15} />&nbsp;انصراف</Button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    }
                    <Row>
                        <Col md={7}>
                            <Table responsive={true} className="fixedTable flexTable mt-1">
                                <thead>
                                    <tr>
                                        <th>نوع موجودیت</th>
                                        <th>نام فیلد</th>
                                        <th>تفصیلی مرتبط</th>
                                        <th style={{ minWidth: "50px", maxWidth: "50px" }}></th>
                                    </tr>
                                </thead>
                                <tbody style={{ maxHeight: "55vh" }}>
                                    {mapping && Array.isArray(mapping) &&
                                        mapping.map((item, i) =>
                                            <tr key={i} className="resultTableRow">
                                                <td>{item.DocumentForDesc}</td>
                                                <td>{item.DocRowAutoColumnDesc}</td>
                                                <td>{item.AccountName}</td>
                                                <td style={{ minWidth: "50px", maxWidth: "50px" }}>
                                                    <PencilFill size={17} style={{ color: "#ff6f00" }} className="rowBtn" onClick={() => setCurrentRow(item)} /></td>
                                            </tr>
                                        )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    )
}
export default AutoDocumentMapping;